import { Injectable } from 'injection-js';
import { Module } from 'shared/core';
import { Zoom } from 'shared/lib';

// Deliberately not Display.isMobile$'s 992px MOBILE_BREAKPOINT (see
// shared/core/display.ts): that's a single shared signal also driving menu
// docking, the hamburger toggle, and basket docking across every storefront
// app, so widening/narrowing it here would shift all of those unrelated
// layouts too. The touch zoom overlay should only replace the desktop
// hover-zoom below the gallery's own CSS "mobile" switchover point
// (media-breakpoint-down(md) in styles/webshop/modules/product.scss, which
// on this project's Bootstrap 5 resolves to 768px) - a desktop/tablet window
// resized down to exactly 768px should still get the familiar
// hover/click-to-dock zoom.
const ZOOM_OVERLAY_BREAKPOINT = 768;

@Injectable()
export class ProductGalleryModule extends Module {
  private zoomablePhoto = $('#productPhoto');
  private zoomableContainer = $('#zoomable-container');
  private mainPhoto = $('#main_image');
  private thumbs = $('.productThumb');
  private hoverOverMessage = $('.product-details-td-gallery-legend');
  private zoom: Zoom;

  public init(): void {
    this.createZoom();
    this.thumbs.on('click', e => this.changePhoto($(e.target)));
  }

  private createZoom(): void {
    // Sampled once, at module init - a window resize or orientation change
    // that crosses ZOOM_OVERLAY_BREAKPOINT during the same page view isn't
    // re-evaluated. The overlay CSS itself now keys off a marker class Zoom
    // adds only when actually built with overlay: true (see zoom.ts), not
    // off this breakpoint again, so this can no longer leave the overlay
    // fullscreen chrome active with the wrong styling - but the underlying
    // "wrong mode for the current width" limitation is still there: rotating
    // a tablet from portrait (loaded with the overlay wired up) to landscape
    // still leaves a tap opening the fullscreen overlay rather than getting
    // desktop hover-zoom, and the reverse direction can leave swinxyzoom's
    // own un-styled small docked hover preview responding to a tap instead
    // of nothing. Known limitation, not fixed here - flag it in QA notes
    // rather than treat it as a regression if raised.
    //
    // document.documentElement.clientWidth, not window.innerWidth: with a
    // classic (non-overlay) scrollbar, @media evaluates against the
    // viewport excluding the scrollbar while innerWidth includes it - a
    // ~15px band where the two disagree with no resize involved, just an
    // unlucky window size on load. clientWidth matches what @media measures.
    const isMobile = document.documentElement.clientWidth < ZOOM_OVERLAY_BREAKPOINT;
    this.zoom = new Zoom({
      selector: '#productPhoto',
      size: '100%',
      overlay: isMobile,
    });
  }

  private changePhoto(target: JQuery): void {
    if (typeof target === typeof undefined || target.length == 0) {
      return;
    }

    const isZoomable: boolean = (<HTMLImageElement>target.closest('.productThumb')
      .find('.invisible-zoomed img')[0]).naturalWidth > 1000;

    const viewSrc = target.closest('.productThumb').data('viewSrc')

    if (typeof viewSrc === typeof undefined) {
      return;
    }
    

    if (isZoomable) {
      const zoomSrc = target.closest('.productThumb').data('zoomSrc')
      this.zoomablePhoto.attr('src', viewSrc);
      (this.zoomablePhoto as any).swinxyzoom('load', viewSrc, zoomSrc);
      this.mainPhoto.hide();
      this.zoomableContainer.show();
      this.hoverOverMessage.show();
    } else {
      this.mainPhoto.attr('src', viewSrc);
      this.mainPhoto.show();
      this.zoomableContainer.hide();
      this.hoverOverMessage.hide();
    }
  }

  public cleanup(): void {
    /* Since Turbolinks does not interfere with browser local events Zoom needs to be cleaned up manually */
    this.zoomablePhoto.detach();
    this.zoomablePhoto.appendTo('.product-details-td-gallery-image');
    $('.sxy-zoom-container').remove();
    this.zoom.cleanup();
  }
}
